import { Route, Routes } from "react-router-dom";
import { Routes as DashboardRoutes } from "./routes";
import { DashboardRouterCmp } from "./types";
import { DashboardPage } from "../pages";



// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DashboardRouter: DashboardRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={DashboardPage.route} element={<DashboardPage />} />
      </Routes>
    </>
  );
};

DashboardRouter.route = DashboardRoutes.DashboardRouter;

export default DashboardRouter;
